import { defineMessages } from 'react-intl';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

import config from '@plone/volto/registry';

const messages = defineMessages({
  pageheaderBlockTitle: {
    id: 'PageheaderBlockTitle',
    defaultMessage: 'PageHeader',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  width: {
    id: 'Width',
    defaultMessage: 'Width',
  },
  height: {
    id: 'Height',
    defaultMessage: 'Height',
  },
  image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  showTitle: {
    id: 'showtitle',
    defaultMessage: 'Show title',
  },
  button: {
    id: 'Button',
    defaultMessage: 'Button',
  },
  buttonLink: {
    id: 'buttonLink',
    defaultMessage: 'Button Link',
  },
  buttonText: {
    id: 'buttonText',
    defaultMessage: 'Button Text',
  },
  textColor: {
    id: 'textColor',
    defaultMessage: 'Text color',
  },
  align: {
    id: 'align',
    defaultMessage: 'Text align',
  },
  BlockWidth: {
    id: 'blockwidth',
    defaultMessage: 'Block Width',
  },
});

export function PageHeaderSchema(props) {
  const { intl, data, formData } = props;
  let schema = {
    title: props.intl.formatMessage(messages.pageheaderBlockTitle),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },
    ],
    properties: {},
    required: [],
  };

  // get text colors from which blocks config
  const blocktype = data?.['@type'] || formData?.['@type'] || 'pageheader';
  const textColors = config.blocks?.blocksConfig[blocktype].textColors;

  addStyling({ schema, intl });

  schema.properties.styles.schema.properties.textColor = {
    title: intl.formatMessage(messages.textColor),
    widget: 'color_picker',
    colors: textColors,
    default: 'pageheader-custom-color-1',
  };
  schema.properties.styles.schema.fieldsets[0].fields = ['textColor'];

  schema.properties.styles.schema.properties['blockWidth:noprefix'] = {
    widget: 'blockWidth',
    title: intl.formatMessage(messages.BlockWidth),
    default: 'default',
    filterActions: ['narrow', 'default', 'layout'],
    actions: config.blocks.widths,
  };
  schema.properties.styles.schema.fieldsets[0].fields.push(
    'blockWidth:noprefix',
  );

  schema.properties.styles.schema.properties.align = {
    widget: 'align',
    title: intl.formatMessage(messages.align),
    actions: ['left', 'right', 'center'],
    default: 'left',
  };

  schema.properties.styles.schema.fieldsets[0].fields.push('align');

  return schema;
}

export const pageheaderSchemaEnhancer = ({ schema, formData, intl }) => {
  schema.fieldsets[0].fields.push('url', 'showTitle');
  schema.properties.url = {
    title: intl.formatMessage(messages.image),
    widget: 'image',
  };
  schema.properties.showTitle = {
    title: intl.formatMessage(messages.showTitle),
    type: 'boolean',
  };

  return schema;
};
